import { AwardTeamMemberFilterBarWrapper } from 'components/ShiftModal/src/views/AwardTeamMemberView/AwardTeamMemberFilterBar.styled';
import { FC } from 'react';

export const AwardTeamMemberFilterBar: FC<{ isOpen: boolean }> = ({ isOpen, children }) => {
  return (
    <AwardTeamMemberFilterBarWrapper isOpen={isOpen}>{children}</AwardTeamMemberFilterBarWrapper>
  );
};
